import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';

import { QuickSightDashboardModule } from '../../quick-sight-dashboard/quick-sight-dashboard.module';
import { AdminDashboardComponent } from './admin-dashboard.component';
import { LogshipStatusComponent } from './logship-status.component';

@NgModule({
  declarations: [AdminDashboardComponent, LogshipStatusComponent],
  imports: [CommonModule, ButtonModule, DialogModule, TabViewModule, TooltipModule, QuickSightDashboardModule],
  exports: [AdminDashboardComponent],
})
export class AdminDashboardModule {}
